import { render } from "./AppBanners.vue?vue&type=template&id=1589fed4&scoped=true"
import script from "./AppBanners.vue?vue&type=script&lang=js"
export * from "./AppBanners.vue?vue&type=script&lang=js"

import "./AppBanners.vue?vue&type=style&index=0&id=1589fed4&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1589fed4"]])

export default __exports__